import styled from 'styled-components';

// Material-UI
import Slider from '@material-ui/core/Slider';

// *************************************
// STYLED COMPONENTS                           
// *************************************
export const StyledSlider = styled(Slider)`
  &.MuiSlider-root {
    color: ${(props) => props.theme.colors.blueMedium};
    padding: 12px 0;
  }

  .MuiSlider-track,
  .MuiSlider-rail {
    height: 3px;
    border-radius: 3px;
  }

  .MuiSlider-track,
  .MuiSlider-rail,
  .MuiSlider-thumb {
    transition: all 120ms ease-out;
  }

  .MuiSlider-thumb:hover {
    box-shadow: 0px 0px 0px 8px rgba(0, 175, 215, 0.25)
  }

  .MuiSlider-thumb.MuiSlider-active {
    box-shadow: 0px 0px 0px 14px rgba(0, 175, 215, 0.25)
  }
`;
